const rankings = [
  { rank: 1, title: '繁花', heat: '985万', genre: '年代剧情', note: '口碑爆款', color: 'bg-accent-500' },
  { rank: 2, title: '庆余年第二季', heat: '967万', genre: '古装权谋', note: '强势回归', color: 'bg-accent-400' },
  { rank: 3, title: '狂飙', heat: '942万', genre: '刑侦扫黑', note: '经典重温', color: 'bg-accent-400' },
  { rank: 4, title: '长相思', heat: '918万', genre: '古装仙侠', note: '热度持续', color: 'bg-secondary-500' },
  { rank: 5, title: '与凤行', heat: '896万', genre: '古装奇幻', note: '新剧上榜', color: 'bg-secondary-500' },
  { rank: 6, title: '玫瑰的故事', heat: '872万', genre: '都市情感', note: '热议不断', color: 'bg-secondary-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-600 text-xs font-medium mb-3">
            <i className="ri-fire-line"></i>
            实时热度
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-2">全网热播剧集实时排名，每30分钟更新一次</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="group relative p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200/70 border border-background-200/60 transition-all cursor-pointer"
            >
              <div className="flex items-start gap-3">
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-lg text-white text-xs font-bold shrink-0 ${item.color}`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 truncate">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.genre}</p>
                  <div className="flex items-center gap-1.5 mt-1.5">
                    <span className="text-sm font-heading font-bold text-accent-500">{item.heat}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-600 whitespace-nowrap">
                      {item.note}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}